import { baseApi } from '@/api/core/baseApi';
import { unwrapListResponse } from '@/api/patterns/crud';
import type { CancelledOrgRow } from '../types';

export const cancelledOrgsApi = baseApi.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    getCancelledOrganizations: builder.query<CancelledOrgRow[], void>({
      query: () => '/platform/cancelled-organizations',
      transformResponse: unwrapListResponse<CancelledOrgRow>,
      providesTags: [{ type: 'PlatformOrganizations', id: 'CANCELLED-LIST' }],
    }),
  }),
});

export const { useGetCancelledOrganizationsQuery } = cancelledOrgsApi;
